<mat-form-field class="acf-full-width" >
  <mat-label class="color-box">{{label() | translate}}</mat-label>
  <input [disabled]="disabled()" (click)="filter()" type="text" aria-label="range" placeholder="{{placeholder() | translate}}" matInput [matAutocomplete]="range" [required]="required()!" [(ngModel)]="this.ngModel" (ngModelChange)="filterChange(); this.ngModelChange.emit($event)" [name]="name()!">
  <mat-autocomplete autoActiveFirstOption #range="matAutocomplete" [displayWith]="displayWith" ngDefaultControl>
    @for (option of filteredOptions$ | async; track option) {
      <mat-option [value]="option">
        {{ getLabel(option) }}
      </mat-option>
    }
  </mat-autocomplete>
  <mat-error>
    {{error() | translate}}
  </mat-error>
</mat-form-field>